<div class="mb-8">
  <app-form-title-with-subtitle>
    <span title>Wprowadź nowe hasło</span>
    <span subtitle>Ustaw nowe hasło i odblokuj dostęp do swojego konta</span>
  </app-form-title-with-subtitle>
</div>

<div class="mb-8">
  <app-alerts />

  @if (isFormVisible()) {
    <app-reset-password-form
      (submitClickEvent)="handleSubmitClickEvent($event)" />
  }
</div>

<div class="text-center">
  <ng-content select="[sign-in-slot]" />
</div>
